module.exports = __webpack_public_path__ + "media/images/common/cart_title-5bec4298fb7232e65dd12944afe21c9c.png";